const generateData = (rows, query) => {
  const newData = rows.map((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    invoiceId: row?.['invoice_id'], // 1349 شناسه فاکتور
    billNumber:  row?.['invoice_billnumber'], // شناسه قبض
    issueDate: row?.['invoice_issuancedate_persian_date'], // تاریخ صدور
    issueTime: row?.['invoice_issuancedate_persian_time'], // زمان صدور
    tax: row?.['invoice_vat'], // مالیات
    totalAmount: row?.['invoice_total_amount'], // مبلغ کل 
    amountPayable: row?.['invoice_payable_amount'], // مبلغ قابل پرداخت
    dateOfPayment: row?.['invoice_paymentdate_persian_date'], // تاریخ پرداخت
    timeOfPayment: row?.['invoice_paymentdate_persian_time'], // زمان پرداخت
    invoiceStatus: row?.['invoice_status_name'], // وضعیت فاکتور
    guildName: row?.['invoice_guild_name'], // نام حساب تفصیلی کسب‌وکار
    decreased: row?.['invoice_is_edited'], // ویرایش یافته
    1355: row?.['invoice_edited_invoice_id'], // شناسه فاکتور ویرایش یافته
    1385: row?.['invoice_parent_invoice_id'], // شناسه فاکتور اصلی
    guildId: row?.['invoice_guild_id'], // شناسه حساب تفصیلی کسب‌وکار,
    paymentMethod: row?.['bill_payment_tool_name'],
    cardNumber: row?.['bill_paymenttoolmask'], // شماره کارت
    shaparakPayment: row?.['bill_shaparaktracenumber'], // شماره پیگیری شاپرک
    payable: row?.['invoice_payable_amount'],
    userId: row?.['bill_user_id'],
  }));

  return newData;
};





// const generateData = (rows, query) => {
//   const newData = rows.map((row, key) => ({
//     num: query?.page * query?.pageSize + key + 1,
//     invoiceId: row.cols[0], // 1349 شناسه فاکتور
//     issueDate: row.cols[1], // تاریخ صدور
//     issueTime: row.cols[2], // زمان صدور
//     tax: row.cols[3], // مالیات
//     amountPayable: row.cols[4], // مبلغ قابل پرداخت
//     dateOfPayment: row.cols[5], // تاریخ پرداخت
//     timeOfPayment: row.cols[6], // زمان پرداخت
//     invoiceStatus: row.cols[7], // وضعیت فاکتور
//     guildName: row.cols[8], // نام حساب تفصیلی کسب‌وکار
//     decreased: row.cols[9], // کاهش یافته
//     1355: row.cols[10], // شناسه فاکتور کاهش یافته
//     hasMultiInvoice: row.cols[11], // تسهیم
//     1385: row.cols[12], // شناسه فاکتور اصلی
//     mainMultiInvoice: row.cols[13], // فاکتور اصلی تسهیمی
//     guildId: row.cols[14], // شناسه حساب تفصیلی کسب‌وکار,
//     paymentMethod: row.cols[22],
//     cardNumber: row.cols[18],
//     shaparakPayment: row.cols[24],
//     payable: row.cols[25],
//     userId: row.cols[15],
//   }));

//   return newData;
// };

// const generateData = (rows, query) => {
//   const newData = rows.map((row, key) => {
//     return {
//       num: query?.page * query?.pageSize + key + 1,
//       ...row,
//     };
//   });

//   return newData;
// };

export default generateData;
